import { updateLessonCacheChirp } from '../lessons/lessonQueries';
import { useGetHydratedTrackQuery } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/TrackChirpService.hooks';
import { useDataFetchingClient } from '../../utils/DataFetchingClient';
export const useFullChirpTrack = trackId => {
  const client = useDataFetchingClient();
  const {
    data,
    loading: trackLoading,
    error: trackError
  } = useGetHydratedTrackQuery({
    variables: {
      trackId
    },
    skip: trackId === null || isNaN(trackId) || !trackId,
    onCompleted(trackData) {
      trackData.result.track.lessons.forEach(lesson => {
        updateLessonCacheChirp(lesson, client);
      });
    }
  });
  return {
    track: data === null || data === void 0 ? void 0 : data.track,
    trackLoading,
    trackError
  };
};